import { Link } from "react-router-dom";
import { Printer } from "lucide-react";
import { usePrinterStatus } from "@/pos/lib/printerStatus";

export default function PrinterBadge({ compact }) {
  const st = usePrinterStatus();
  return (
    <Link to="/pos/tetapan" title={`Printer: ${st.label}`} data-testid={compact ? "printer-status-badge-mobile" : "printer-status-badge"}
      className={`flex items-center gap-2 rounded-full font-semibold transition-colors ${compact ? "bg-white/95 px-3 py-1.5 text-xs shadow-lg" : "mb-3 bg-white/5 px-3 py-1.5 text-[11px] text-slate-200 hover:bg-white/10"}`}>
      <span className="relative flex h-2.5 w-2.5">
        {st.ok && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-60" />}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${st.ok ? "bg-green-500" : "bg-red-500"}`} data-testid="printer-status-dot" data-ok={st.ok} />
      </span>
      <Printer size={13} className={compact ? (st.ok ? "text-green-700" : "text-red-600") : ""} />
      <span className={compact ? (st.ok ? "text-green-800" : "text-red-700") : ""}>{compact ? (st.ok ? "Printer OK" : "Printer X") : `Printer: ${st.label}`}</span>
    </Link>
  );
}
